import axios from './axios'
import useAuth from '../context/useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/api/auth/refresh', {
            withCredentials: true
        });
        setAuth(prev => {
            return {
                ...prev,
                name: response?.data?.name,
                userId: response?.data?.userId,
                role: response.data.role,
                accessToken: response.data.accessToken
            }
        })
        return response.data.accessToken;

    }

    return refresh;

}

export default useRefreshToken;